import React, { Fragment } from 'react';
import Upload from './Upload';
import Requirements from './Requirements';
import badDefault from '../../images/bad.png';
import goodDefault from '../../images/good.png';

const good = [
  'Full face and top of shoulders',
  'Face is centered in the frame',
  'One person in the picture only',
  'Good lighting',
];
const bad = ['No hats or sunglasses', 'Not blurry', 'Cannot use photo of a photo', 'Cannot be black & white'];
const description = 'As a standard rule, think "passport photo" with a smile.';

const ProfilePhoto = props => (
  <Fragment>
    <h2 className="upload-header">Profile Picture</h2>

    {props.uberProfileImage ? null : (
      <Requirements good={good} bad={bad} description={description}>
        <div className="my-profile-form" style={{ paddingBottom: '30px' }}>
          <div className="name-pic">
            <div className="picture-div">
              <img
                id="profile-picture"
                className="profile-picture"
                src={goodDefault}
                alt="Profile"
                role="presentation"
              />
            </div>
          </div>

          <div className="bad-picture-div">
            <img
              id="profile-picture"
              className="bad-profile-picture"
              src={badDefault}
              alt="Profile"
              role="presentation"
            />
          </div>
        </div>
      </Requirements>
    )}

    <Upload {...props} />
  </Fragment>
);

export default ProfilePhoto;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/ProfilePhoto.js